module.exports = __webpack_public_path__ + "static/media/phone-square.9f91c309.svg";